import { CreateTicketForm } from '../components/CreateTicketForm';

export function CreateTicket() {
  return <CreateTicketForm />;
}
